module.exports = __webpack_public_path__ + "media/images/covid/cs/crowded_places-8fe7526e5b0294465fd85e10296df66b.png";